"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCustomerScope = void 0;
const tools_1 = require("../../tools");
const types_1 = require("../../types");
const utils_1 = require("../utils/utils");
const resolveItemScope_1 = require("./resolveItemScope");
const resolveCustomerScope = (metaExpression, options) => {
    if (metaExpression.scope !== types_1.META_EXPRESSION_SCOPE.CUSTOMER)
        throw new tools_1.InternalError("MetaExpression Scope not align.");
    let listCustomer;
    let itemCustomer;
    let newOptions = Object.assign({}, options);
    // frontend stores this info in listCustomer and customer
    if (options.listCustomer && options.customer) {
        listCustomer = options.listCustomer;
        itemCustomer = options.customer;
        newOptions = Object.assign(Object.assign({}, options), { list: listCustomer, item: itemCustomer });
        // not used anymore in the resolution. has been replaced above by list and item
        delete newOptions.listCustomer;
        delete newOptions.customer;
    }
    const { list } = newOptions;
    if (!list || list.id !== "customer")
        return (0, utils_1.getMeResultNoResult)();
    return (0, resolveItemScope_1.resolveItemScope)(Object.assign(Object.assign({}, metaExpression), { scope: types_1.META_EXPRESSION_SCOPE.ITEM }), newOptions);
};
exports.resolveCustomerScope = resolveCustomerScope;
